export interface UserLightResponse {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
}

export type UserResponse = UserLightResponse & {
  azureOid: string;
  manager: UserLightResponse | null;
  department: string | null;
  preferredLanguage: string;
  isAdmin: boolean;
  lastAccess: string | null;
  createdAt: string;
  updatedAt: string;
};

export interface CreateUserRequest {
  email: string;
}

export function formatUserName(user: UserLightResponse) {
  return `${user.firstName} ${user.lastName}`;
}
